/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingModule_item = {
    readonly storyTellingModule: {
        readonly tabs: ReadonlyArray<{
            readonly tabTitle: string;
            readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingTab_item">;
    readonly " $refType": "PdpRespStorytellingModule_item";
};
export type PdpRespStorytellingModule_item$data = PdpRespStorytellingModule_item;
export type PdpRespStorytellingModule_item$key = {
    readonly " $data"?: PdpRespStorytellingModule_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingModule_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespStorytellingModule_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "storyTellingModule",
      "storageKey": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tabs",
          "storageKey": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "tabTitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespStorytellingTab_storyTellingTab",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespStorytellingTab_item",
      "args": null
    }
  ]
};
(node as any).hash = 'e2ef43e9d6e5a97831c4f3cfeb67b28e';
export default node;
